import { render, staticRenderFns } from "./HeadersConfig.vue?vue&type=template&id=2a144142"
import script from "./HeadersConfig.vue?vue&type=script&lang=js"
export * from "./HeadersConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports